export const AhrefsIcon = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M4.9576 5.46731H12.6603V7.69492L9.77176 7.92736C5.08975 8.25666 3.61719 9.53511 3.61719 13.0993V13.816C3.61719 16.431 5.39182 18 8.12928 18C10.3004 18 11.5275 17.477 13.0567 15.8692H13.3021V17.5739H16.3794V2H4.9576V5.46731ZM12.6603 12.9637C11.6974 13.9516 10.2815 14.5908 9.09211 14.5908C7.82722 14.5908 7.27972 14.1065 7.31748 13.0218C7.35524 11.5109 7.88385 11.1622 10.3381 10.9298L12.6603 10.7167V12.9637Z"
        fill="#FF8800"
      />
    </svg>
  );
};
